import Media from './MediaContainer';

export default Media;
